import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var pull_left_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M4 18h6V6H4v12zm9-9.5V10h7V8.5h-7zm0 7h7V14h-7v1.5z" }) });
export {
  pull_left_default as default
};
//# sourceMappingURL=pull-left.js.map
